import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Box, Stack, Pagination, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Unstable_Grid2";

import InClinicSearch from "../components/InClinicSearch";
import CardContainer from "../components/CardContainer";
import EnterOrderForm from "../components/EnterOrderForm";

const EnterOrder = () => {
  const [inClinic, setInClinic] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const orderId = useSelector((state) => state.orderReducers.orderId);
  //getting the data from search component
  const getOrderData = (data, count) => {
    setInClinic(data);
    setPageCount(count);
  };

  return (
    <React.Fragment>
      <Paper sx={{ flexGrow: 1, p: 2, maxWidth: "1200px !important" }}>
        <Typography variant="h5" align="center" sx={{ mb: 5 }}>
          ورود سفارش
        </Typography>
        <Grid container spacing={4}>
          <Grid md={12}>
            <InClinicSearch
              getOrderData={getOrderData}
              page={page}
              rowCount={4}
            />
          </Grid>
          <Grid md={12}>
            <CardContainer data={inClinic} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                mt: 4,
              }}
            >
              <Stack spacing={2}>
                <Pagination
                  count={pageCount}
                  onChange={(_event, value) => setPage(value)}
                />
              </Stack>
            </Box>
          </Grid>
          <Grid md={12}>
            <hr />
          </Grid>
        </Grid>
        {orderId ? (
          <EnterOrderForm orderId={orderId} />
        ) : (
          <Chip label="لطفا یک سفارش را انتخاب کنید." color="error" />
        )}
      </Paper>
    </React.Fragment>
  );
};

export default EnterOrder;
